import Api from "./Api";
import store from "../state/store";

export default {
  async fetchVisitsSummary(start_date, end_date) {
    const res = await Api({ daemonRequest: false }).get(
      `/visit_summary/${store.getters["authfack/currentEntity"].id}?start=${start_date}&end=${end_date}`
    );
    return res.data;
  },
  getSitesAndAreasByEntityId() {
    return Api().get(`/sites_list/${store.getters["authfack/currentEntity"].id}`);
  },
  getAllSitesWithAreasByEntityId() {
    return Api().get(`/sites/areas/${store.getters["authfack/currentEntity"].id}`);
  },
  getAreaDataById(id){
    return Api().get(`/area/${id}`);
  },
  userTypesWithAreaId(id) {
    return Api().get(`/user-types/area/${id}`);
  },
  searchForUser(payload) {
    return Api().post(`/users/search/${store.getters["authfack/currentEntity"].id}`, payload);
  },
  searchForHost(payload) {
    return Api().post('/host/search', payload);
  },
  getUsersByEmailOrPhone(payload){
    return Api().post(`/check-unique-field`, payload);
  },
  chechIfUserHasExpextedVisit(payload){
    return Api().post(`/expected-visit-validate`, payload);
  },
  addExpextedVisit(payload){
    return Api().post(`/expected-visit`, payload);
  },
  checkIfJourneyHasHost(payload){
    return Api().get(`/hosts/${payload.journeyId}/${payload.userTypeId}`);

  },
  signInOut(params){
    return Api().get("flow-settings",{params});
  },
  signInOutByUserType(params) {
    return Api().get("flow_settings_by_user_type", { params });
  },
};
